import * as React from "react";
const SvgFiBrandsVimeo = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M23.988 6.412q-.16 3.511-4.895 9.614-4.895 6.374-8.282 6.374-2.099 0-3.55-3.882L5.324 11.4Q4.247 7.52 3.013 7.519q-.27.001-1.883 1.133L0 7.195a306 306 0 0 0 3.503-3.13q2.37-2.05 3.556-2.16 2.802-.27 3.449 3.839.699 4.433.97 5.51.807 3.677 1.778 3.676.754 0 2.263-2.385 1.507-2.385 1.616-3.631.215-2.059-1.616-2.06-.863 0-1.776.394 1.77-5.805 6.759-5.644 3.699.109 3.486 4.808"
    />
  </svg>
);
export default SvgFiBrandsVimeo;
